
  import index from "./index.js";
  export default index;
